import { render, staticRenderFns } from "./biangeng.vue?vue&type=template&id=f7ab818c"
import script from "./biangeng.vue?vue&type=script&lang=js"
export * from "./biangeng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports